import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8def86a95d1d9d9/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/KioskCaseStudy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/KioskLocations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskShowcase"] */ "/tmp/8def86a95d1d9d9/components/sections/KioskShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8def86a95d1d9d9/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8def86a95d1d9d9/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8def86a95d1d9d9/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitCard"] */ "/tmp/8def86a95d1d9d9/components/ui/BenefitCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def86a95d1d9d9/components/ui/LazyVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingFactorCard"] */ "/tmp/8def86a95d1d9d9/components/ui/PricingFactorCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/app/[locale]/self-ordering-kiosk/KioskPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
